module.exports = __webpack_public_path__ + "static/media/sponcer_Enlightened.e295e8ab.png";